import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { INK } from "@/theme/tokens";

type NavigationWarningDialogProps = {
	open: boolean;
	onCancel: () => void;
	onConfirmLeave: () => void;
	onPublishAndLeave: () => void;
	changeCount: number;
	isPublishing?: boolean;
};

export const NavigationWarningDialog: FC<NavigationWarningDialogProps> = ({ open, onCancel, onConfirmLeave, onPublishAndLeave, changeCount, isPublishing }) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth data-testid="navigation-warning-dialog">
			<DialogTitle sx={{ color: INK.SECONDARY, fontWeight: 600 }}>{t("draft.mode.unsaved.changes")}</DialogTitle>
			<DialogContent>
				<DialogContentText sx={(theme) => ({ color: theme.palette.primary.light })}>
					{t("draft.mode.unsaved.changes.message", { count: changeCount, changes: changeCount === 1 ? "change" : "changes" })}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
				<Button onClick={onCancel} color="inherit" variant="outlined" data-testid="navigation-warning-cancel-button">
					{t("draft.mode.stay.on.page")}
				</Button>
				<Button onClick={onConfirmLeave} color="error" variant="outlined" data-testid="navigation-warning-leave-button">
					{t("draft.mode.leave.without.saving")}
				</Button>
				<Button onClick={onPublishAndLeave} color="primary" variant="contained" disabled={isPublishing} data-testid="navigation-warning-publish-button">
					{isPublishing ? t("draft.mode.publishing") : t("draft.mode.publish.and.leave")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
